<div
  class="kwikui-radio-chip-wrapper"
  [class.vertical]="orientation === 'vertical'"
  [class.horizontal]="orientation === 'horizontal'"
  [class.wrapped]="orientation === 'wrapped'"
  [class.invalid]="invalid"
  [class.focused]="focus"
  [class.disabled]="disabled"
  [attr.data-size]="size"
>
  <div
    *ngFor="let item of items; let i = index"
    class="radio-chip"
    [class.selected]="formControl.value === item.value"
    [class.disabled]="item.disabled || disabled"
    [class.invalid]="invalid"
    [class.focused]="focus && formControl.value === item.value"
  >
    <label class="radio-label">
      <input
        type="radio"
        [value]="item.value"
        [formControl]="formControl"
        [disabled]="item.disabled || disabled"
        [readonly]="properties.readOnly"
        [attr.name]="formControlName"
        [readonly]="properties.readOnly"
      />
      <div>{{ item.label }}</div>
      <div
        *ngIf="item?.description?.length > 0"
        class="description"
        [innerHtml]="item.description | kwikuiSafeHtml"
      ></div>
    </label>
  </div>
</div>
